module.exports = __webpack_public_path__ + "static/media/sign.05afba85.png";